import { Box, CardMedia, Chip, Grid, Paper, Typography, IconButton } from '@mui/material';
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Colors from '../../../Assets/Styles/Colors';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import { baseUrl } from "../../../../axios";
import moment from 'moment';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function JobDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log(state);
  return (
    <Box
      sx={{
        borderRadius: "12px",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          background: Colors.primaryGradient,
          p: 2,
          borderRadius: "12px",
        }}
      >
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IconButton onClick={() => navigate(-1)}>
              <KeyboardArrowLeft sx={{ color: Colors.white }} />
            </IconButton>
            <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
              Job Details
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <BreadCrumbs currentPage={["Job Details"]} />
        </Grid>
      </Grid>
      <Box sx={{ mt: "20px" }}>
        <Box
          component={Paper}
          sx={{
            borderRadius: "4px",
            boxShadow: "0px 0px 10px 2px #e3e3e3"
          }}
        >
          <Grid container>
            <Grid item md={12} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  p: "20px",
                }}
              >
                <Swiper
                  spaceBetween={10}
                  slidesPerView={1}
                  className='mySwiper'
                  onSlideChange={() => console.log('slide change')}
                  onSwiper={(swiper) => console.log(swiper)}
                  modules={[Pagination, Navigation]}
                  navigation
                  pagination={{ clickable: true }}
                >
                  {state?.image ? state?.image?.map((img, i) => (
                    <SwiperSlide key={i}>
                      <Box sx={{ height: "400px", width: "100%", display: "flex", justifyContent: "center" }}>
                        <CardMedia component={"img"} src={baseUrl + img} sx={{ height: "400px", width: "450px", objectFit: "contain" }} />
                      </Box>
                    </SwiperSlide>
                  )) : state?.adId?.image?.map((img, i) => (
                    <SwiperSlide key={i}>
                      <Box sx={{ height: "400px", width: "100%", display: "flex", justifyContent: "center" }}>
                        <CardMedia component={"img"} src={baseUrl + img} sx={{ height: "400px", width: "450px", objectFit: "contain" }} />
                      </Box>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            </Grid>
            <Grid item md={12}>
              <Grid container justifyContent={"space-between"} sx={{ height: "100%" }}>
                <Grid item md={12}>
                  <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Box sx={{ display: "flex", width: "100%" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                          Job Details:
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", width: "100%", justifyContent: "flex-end", gap: "10px" }}>
                        <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Status:</Typography>
                        <Typography variant={"subtitle1"}>
                          {/* <Chip
                            label={
                              state?.isCompleted == true ?
                                "Completed"
                                : state?.isApproved == null ?
                                  "Pending"
                                  : state?.isApproved == true ?
                                    "Posted"
                                    : "Disapproved"
                            }
                            sx={{
                              bgcolor: state?.isCompleted == true ? Colors.gunMetal : state?.isApproved == true ? Colors.success + 26 : state.isApproved == true ? Colors.success + 26 : Colors.pending + 26,
                              color: state?.isCompleted == true ? Colors.white : state?.isApproved == null ? Colors.danger : state?.isApproved == true ? Colors.success : Colors.pending,
                              height: 26,
                              textTransform: 'capitalize',
                            }}
                          /> */}
                          <Chip
                            label={
                              state?.isHired == true && state?.isCompleted == true ?
                                "Completed"
                                : state?.isHired == true ?
                                  "Active"
                                  : state?.isApproved == null ?
                                    "Pending"
                                    : state?.isApproved == true ?
                                      "Posted"
                                      : "Disapproved"
                            }
                            sx={{
                              bgcolor:
                                state?.isHired == true && state?.isCompleted == true ? Colors.gunMetal
                                  : state?.isApproved == null ? Colors.danger + 26
                                    : state.isApproved == true ? Colors.success + 26
                                      : Colors.pending + 26,
                              color:
                                state?.isHired == true && state?.isCompleted == true ? Colors.white
                                  : state?.isApproved == null ? Colors.danger
                                    : state?.isApproved == true ? Colors.success
                                      : Colors.pending,
                              height: 26,
                              textTransform: 'capitalize',
                            }}
                          />
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={12}>
                  <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                    <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                      <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Category:</Typography>
                      <Box sx={{ display: "flex", gap: "8px" }}>
                        {state?.category ?
                          state?.category.map((item) => <Typography variant={"subtitle1"}>{item.name}</Typography>) :
                          state?.adId?.category?.map((item) => <Typography variant={"subtitle1"}>{item.name}</Typography>)
                        }
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={12}>
                  <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                    <Grid container spacing={2}>
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                          <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Posted By:</Typography>
                          <Typography variant={"subtitle1"}>{state?.adId ? state?.adId?.postedBy?.name : state?.postedBy?.name ?? "-"}</Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                          <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Title:</Typography>
                          <Typography variant={"subtitle1"}>{state?.adId ? state?.adId?.title : state?.title}</Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                          <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Budget:</Typography>
                          <Typography variant={"subtitle1"}>PKR {state?.budget}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item md={12}>
                  <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                    <Grid container spacing={2}>
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                          <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Date of Creation:</Typography>
                          <Typography variant={"subtitle1"}>{moment(state?.createdAt).format("DD-MM-YYYY")}</Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                          <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Valid Till:</Typography>
                          <Typography variant={"subtitle1"}>{moment(state?.valid_till).format("DD-MM-YYYY")}</Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                          <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Duration:</Typography>
                          <Typography variant={"subtitle1"}>{state?.jobDuration}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item md={12}>
                  <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                    <Grid container spacing={2}>
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                          <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>No. of Propsals:</Typography>
                          <Typography variant={"subtitle1"}>{state?.totalProposals}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12}>
              <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                  <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Description:</Typography>
                  <Typography variant={"subtitle1"}>{state?.adId ? state?.adId?.description : state?.description ?? "-"}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box >
  )
}

export default JobDetails